import React from 'react';
import { useState, useContext } from 'react';
import quizInstanceAdminStatusContext from '../context/quizInstanceAdminStatusContext';
import QuizAdminProgressBar from './QuizAdminProgressBar';

export default function QuizAdminResultTimer() {

  const ctx = useContext(quizInstanceAdminStatusContext);
	const [label, setLabel] = useState("");
	const updateLabel = updateArgs => {
		setLabel(`Tid kvar (${updateArgs.remainingMinutesAndSeconds})`);
	};

	return (
		<div className="quizAdminResultTimer">
			<QuizAdminProgressBar 
				startedAt={ctx.quizInfo.startedAt} 
				endsAt={ctx.quizInfo.endsAt} 
				onUpdated={updateLabel}
				onElapsed={() => ctx.callbacks.setForceQuizEnd(true)}
			/>
			{label}
		</div>
	);
}